import Component from '@glimmer/component';

// Renders the nested-div "hexagon" character avatar used across esports widgets.
// Args:
//   @image   - image src (required)
//   @alt     - img alt text (defaults to 'character')
//   @color   - hexagon color modifier class (e.g. 'red', 'cyan', 'blue', 'violet', 'light')
//   @size    - size modifier class (e.g. 'small'); omit for default/medium
//   @prefix  - extra classes prepended before 'hexagon' (e.g. 'featured-info-img')
export default class CharacterAvatar extends Component {
  get wrapClasses() {
    const parts = [];
    if (this.args.prefix) {
      parts.push(this.args.prefix);
    }
    parts.push('hexagon', 'hexagon-wrap');
    if (this.args.size) {
      parts.push(this.args.size);
    }
    if (this.args.color) {
      parts.push(this.args.color);
    }
    return parts.join(' ');
  }
  <template>
    <div class={{this.wrapClasses}}>
      <div class='hexagon-in1'>
        <div class='hexagon-in2 hexagon-wrap'>
          <div class='hexagon inner-hexagon'>
            <div class='hexagon-in1'>
              <div class='hexagon-in2 hexagon-area liquid'>
                <img src={{@image}} alt={{if @alt @alt 'character'}} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
}
